import { SIZE } from '@ui-components/typography/PlayText';
import { HighlightsFragment } from 'app/graphql/__generated__/types/contento';
import React from 'react';
import OpenModal from '../../../VideoModal/OpenModal';
import {
    Highlight,
    HighlightList,
    HighlightPosition,
    HighligthLink,
    StyledHighlights,
} from './highlights.styles';

export type HighlightsProps = {
    highlights: HighlightsFragment[];
    videoId: string;
    videoUrl: string;
};

export const HighLights = ({ highlights, videoId, videoUrl }: HighlightsProps) =>
    highlights?.length ? (
        <StyledHighlights aria-label="Navigera mellan kapitel i videon.">
            <HighlightList>
                {highlights.map((highlight, index) => (
                    <Highlight key={highlight.slug}>
                        <HighlightPosition size={SIZE.LARGE}>{highlight.positionFormatted}</HighlightPosition>
                        <OpenModal
                            videoId={videoId}
                            videoUrl={videoUrl}
                            position={highlight.positionInSeconds}
                            extraQuery={{ highlight: highlight.slug }}
                        >
                            {(onClick) => (
                                <HighligthLink className={`lp_pos${index + 1}`} onClick={onClick}>
                                    {highlight.name}
                                </HighligthLink>
                            )}
                        </OpenModal>
                    </Highlight>
                ))}
            </HighlightList>
        </StyledHighlights>
    ) : null;

export default HighLights;
